//@flow

import { declareAction, declareAtom } from '@reatom/core'

const SetUtmData = declareAction('setUtmDataAction')
// rwReferral приходит асинхронно от rw.js (Rewardful), не из URL — отдельный экшен
export const SetRwReferral = declareAction('setRwReferralAction')
export const StoreUtmData = declareAction(
  'storeUtmDataAction',
  (payload, store) => {
    const urlParams = new URLSearchParams(window.location.search)
    store.dispatch(SetUtmData({
      source: urlParams.get('utm_source'),
      medium: urlParams.get('utm_medium'),
      campaign: urlParams.get('utm_campaign'),
      gclid: urlParams.get('gclid'),
      // Rewardful: слаг аффилиата из ?via= — НЕ валидирован, только для баннера/аналитики.
      // Цену/план по нему НЕ гейтить (см. rwReferral в Payment.js).
      via: urlParams.get('via'),
    }))
  }
)

export const UtmAnalytics = declareAtom(
  'utmAtom',
  {
    utmSource: null,
    utmMedium: null,
    utmCampaign: null,
    gclid: null,
    rwReferral: null,
    rwVia: null,
  },
  on => [
    on(SetUtmData, (state, payload) => {
      return {
        ...state,
        utmSource: payload.source,
        utmMedium: payload.medium,
        utmCampaign: payload.campaign,
        gclid: payload.gclid,
        rwVia: payload.via,
      }
    }),
    on(SetRwReferral, (state, payload) => {
      return { ...state, rwReferral: payload }
    })
  ])
